import {useMemo} from 'react';

export function useIsTablet(): boolean {
  return useMemo(() => {
    if (typeof window === 'undefined' || typeof navigator === 'undefined') {
      return false;
    }

    const hasTouch = navigator.maxTouchPoints > 0;
    const coarsePointer = window.matchMedia('(pointer: coarse)').matches;
    const hoverNone = window.matchMedia('(hover: none)').matches;

    const ua = navigator.userAgent;
    const isMobileUA = /Mobi|iPhone|Android.*Mobile/i.test(ua);

    return hasTouch && coarsePointer && hoverNone && !isMobileUA;
  }, []);
}
